import exercisesClient from './exercisesClient';
import { normalizeCatalog, normalizeExerciseItem, normalizeAttemptResult } from '../models/exerciseMappers';

export class ExercisesRepository {
  constructor(client = exercisesClient) {
    this.client = client;
  }

  async getCatalog() {
    const response = await this.client.get('/api/frontend/v2/exercises/me');
    return normalizeCatalog(response.data);
  }

  async getItem(type, subtype, position) {
    const path = [type, subtype, position].map(value => encodeURIComponent(String(value))).join('/');
    const response = await this.client.get(`/api/frontend/v2/exercises/me/${path}`);
    return normalizeExerciseItem(response.data);
  }

  async submit(type, subtype, payload) {
    const path = [type, subtype].map(value => encodeURIComponent(String(value))).join('/');
    const response = await this.client.post(`/api/frontend/v2/exercises/me/${path}/attempt`, payload);
    return normalizeAttemptResult(response.data);
  }
}

export const exercisesRepository = new ExercisesRepository();
